import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./modules/auth/AuthContext";
import { loadAppSettings } from "./config/appSettings";
import { ListGridToolbar } from "./shared/ListGridToolbar";
import "./styles.css";

const adminTheme = createTheme({
  components: {
    MuiDataGrid: {
      defaultProps: {
        showToolbar: true,
        slots: {
          toolbar: ListGridToolbar
        },
        slotProps: {
          toolbar: {
            quickFilterProps: {
              debounceMs: 300,
              slotProps: {
                root: {
                  placeholder: "Search..."
                }
              }
            }
          }
        }
      }
    }
  }
});

async function bootstrap() {
  await loadAppSettings();

  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <ThemeProvider theme={adminTheme}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>
  );
}

bootstrap();
